import { ENROLMENT_TERMS } from "../../constants/enrolmentTerms";

type Props = {
  checked: boolean;
  onChange: (value: boolean) => void;
  className?: string;
};

const EnrolmentTermsAgreement = ({ checked, onChange, className }: Props) => {
  return (
    <div className={className}>
      <h2 className="font-semibold text-burntBlack mb-2 sm:text-lg text-base">
        Enrolment Terms and Conditions
      </h2>
      <div
        className="border border-black/20 rounded-[10px] p-4 max-h-[220px] overflow-y-auto text-sm text-burntBlack/85 space-y-3 mb-3 shadow-sm"
        role="region"
        aria-label="Enrolment Terms and Conditions"
      >
        {ENROLMENT_TERMS.map(({ id, title, body }) => (
          <p key={id}>
            <span className="font-semibold">
              {id}. {title}:
            </span>{" "}
            {body}
          </p>
        ))}
      </div>
      <label className="flex items-start gap-2 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 size-4 accent-primary cursor-pointer flex-shrink-0"
          aria-label="I agree to the Enrolment Terms and Conditions"
        />
        <span className="text-sm text-burntBlack/85">
          I have read, understood, and agree to the Enrolment Terms and
          Conditions above.
        </span>
      </label>
    </div>
  );
};

export default EnrolmentTermsAgreement;
